










































































import { AxiosError } from 'axios';
import { defineComponent, ref, watch } from '@vue/composition-api';

import { ALForm } from '@/common/component.types';
import { ISystemError } from '@/models/error';
import { useUploadTariffExceptions } from '@/composable/tariff-exceptions';

import FormRules from '@/mixins/file-upload-rules';
import { setErrorFromAxiosError } from '@/utils/helpers';

import DragDropFileInput from '../common/DragDropFileInput.vue';
import ErrorAlert from '../common/ErrorAlert.vue';
import ALDialog from '../core/Dialog/ALDialog.vue';

export default defineComponent({
  name: 'TariffExceptionUploadFileDialog',

  components: { DragDropFileInput, ErrorAlert, ALDialog },

  mixins: [FormRules],

  setup(props) {
    const isDialogActive = ref(false);
    const isFormValid = ref(false);

    const fileUpload = ref<File | null>(null);

    const error = ref<ISystemError | null>(null);

    const formRef = ref<ALForm>();

    watch(isDialogActive, value => {
      if (!value) {
        fileUpload.value = null;
      }
    });

    function clearError() {
      error.value = null;
    }

    function resetFormValidation(): void {
      if (formRef.value) {
        return formRef.value.resetValidation();
      }
    }

    function validateForm(): boolean {
      let valid = false;
      if (formRef.value) {
        valid = formRef.value.validate();
      }
      return valid;
    }

    function close() {
      isDialogActive.value = false;
      clearError();
      resetFormValidation();
    }

    const {
      isLoading,
      mutate: uploadTariffException,
      reset: uploadReset
    } = useUploadTariffExceptions();

    async function uploadTariffExceptionFileHandler() {
      uploadReset();

      const valid = validateForm();

      if (valid) {
        uploadTariffException(fileUpload.value!, {
          onSuccess: () => {
            fileUpload.value = null;
            close();
          },
          onError: err => {
            error.value = setErrorFromAxiosError(err as AxiosError);
          }
        });
      }
    }

    return {
      // REFS
      formRef,

      // DATA
      isDialogActive,
      isLoading,
      isFormValid,
      fileUpload,
      error,

      // METHODS
      uploadTariffExceptionFileHandler,
      clearError,
      close
    };
  }
});
